interface Subroute {
  baseRoute: string;
}

interface Routes {
  application: any;
  applicationNew: string;
  applicationBase: string;
  callback: string;
  error: string;
  home: string;
}

const combineRoutes = <T extends unknown>(baseRoute: string, subRoutes: T): Subroute & T => {
  return {
    baseRoute,
    ...Object.keys(subRoutes as any).reduce(
      (v, k) => ({ ...v, [k]: `${baseRoute}/${subRoutes[k]}` }),
      {}
    ),
  } as any;
};

const applicationSubRoutes = {
  applicant: 'steps/applicant',
  sailor: 'steps/sailor',
  certificate: 'steps/certificate',
  requirements: 'steps/requirements',
  cra: 'steps/cra',
  summary: 'steps/summary',
  payment: 'steps/payment',
};

const baseRoutes = {
  home: '/',
  code: '/code',
  callback: '/callback',
  error: '/error',
  applicationNew: '/newApplication',
  userManagement: '/user-management',
  applicationBase: '/application/:applicationUid',
  paymentWindow: `/paymentWindow`,
};

export const routes = {
  ...baseRoutes,
  ...combineRoutes(baseRoutes.applicationBase, applicationSubRoutes),
};
